/**
 * item 领域的 GameState 分片注册（背包）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { BUILTIN_ITEM_TEMPLATE_IDS } from './itemIds';
import { InventorySchema, type Inventory } from './types/inventory';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    inventory?: Inventory;
  }
}

registerGameStateSlice('inventory', InventorySchema.optional(), () => ({
  gold: 100,
  stackables: [{ definitionId: BUILTIN_ITEM_TEMPLATE_IDS.HP_POTION_SMALL, quantity: 3 }],
  instanceData: {},
}));
